import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { forEach } from 'jszip';

@Injectable({
  providedIn: 'root'
})
export class ImplementosService {
  constructor(private http: HttpClient, private router: Router, private alert: AlertHelper) { }

  //   EnviarArchivo(archivo:any){
  //     return this.http
  //     .post<RequestResponse >(`${environment.API}/rrhh/licencias/documento`,archivo)
  //     .pipe(
  //       map((res:RequestResponse) =>{
  //         return res;
  //       }),
  //       catchError((err)=> this.handlerError(err))
  //     );
  //   }

  arrayImplementos: any[] = [];
  arrayModelos: any[] = [];

  //TraerImplementos
  traerImplementosPorId(id: any): Observable<RequestResponse> {
    return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/documento/buscarimplementosid/${id}`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }

  //TraerArchivo SE COMENTA, NO EXISTE ESTA RUTA EN BACK Y NO SE LLAMA NUNCA
  // traerArchivoImplementos(id:any): Observable<RequestResponse> {
  //   return this.http
  //   .get<RequestResponse >(`${environment.API}/rrhh/implementos/buscarimplementosid/${id}`)
  //   .pipe(
  //     map((res:RequestResponse) =>{ 
  //       return res;
  //     }),
  //     catchError((err)=> this.handlerError(err))
  //   );
  // }
  //CrearImplementos
  crearImplemento(Implementos: any) {
    return this.http
      .post<RequestResponse>(`${environment.API}/rrhh/implementos/crear`, Implementos)
      .pipe(
        map((res: RequestResponse) => {
          this.http.get(`${environment.API}/rrhh/trabajador/obtenerPorId/${Implementos.fk_trabajador}`).subscribe((response: any) => {
            // Asegúrate de verificar si la propiedad 'data' existe y tiene un valor antes de intentar acceder a sus propiedades
            const trabajador = response && response.data && response.data.length > 0 ? response.data[0] : null;

            this.arrayImplementos = [];
            this.arrayModelos = [];
            const equiposE = Object.keys(Implementos).filter(key => key.startsWith('equipo'));
            const modelosE = Object.keys(Implementos).filter(key => key.startsWith('modelo'));

            // Iterar solo sobre las propiedades de "equipo"
            for (const key of equiposE) {
              if (Implementos[key] !== "") {
                this.arrayImplementos.push(Implementos[key]);
              }
            }

            // Iterar solo sobre las propiedades de "modelo"
            for (const key of modelosE) {
              if (Implementos[key] !== "") {
                this.arrayModelos.push(Implementos[key])
              }
            }
          });

          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }


  //TraerPorRut
  traerPorIdTrabajador(id: any): Observable<RequestResponse> {
    return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/implementos/idTrabajador/${id}`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //eliminar
  eliminarImplemento(id: any): Observable<RequestResponse> {
    return this.http
      .delete<RequestResponse>(`${environment.API}/rrhh/implementos/eliminar/${id}`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //TraerTodo
  traerImplementos(): Observable<RequestResponse> {
    return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/implementos/`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //actualizarEstado
  actualizarEstado(implementos: any): Observable<RequestResponse> {
    return this.http
      .put<RequestResponse>(`${environment.API}/rrhh/implementos/actualizarEstado/ ${implementos.id}`, implementos)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //actualizar
  actualizarImplemento(implementos: any): Observable<RequestResponse> {
    return this.http
      .put<RequestResponse>(`${environment.API}/rrhh/implementos/actualizar/ ${implementos.id}`, implementos)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }

  private handlerError(err: any): Observable<never> {

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }
}
